// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2WrG2","footer":"ReportModalFilter_footer__GyJ_F"};